import methods from '@/services/methods'

export default {
  //Authendication
  // =======  user/admin Login api call  =======
  userLogin(request) {
    return methods.post('login', request)
  },

  // =======  forgot password api call  =======
  userLogin(request) {
    return methods.post('login', request)
  },

  //ADMIN
  // --->>>>>>>>>>>>>>>>  update current unit  <<<<<<<<<<<<<<<<<---
  updateCurrentUnit(request) {
    return methods.post('update-current-reading', request)
  },

  // --->>>>>>>>>>>>>>>>  Auto complete missing lots  <<<<<<<<<<<<<<<<<---
  autoCompleteMissingLots(request) {
    return methods.post('set-incomplete-lots-to-zero', request || {})
  },

  //coprops API
  // --->>>>>>>>>>>>>>>>   Get Co Prop list api call   <<<<<<<<<<<<<<<<<---
  getCoPropList() {
    return methods.get('coprops')
  },

  // --->>>>>>>>>>>>>>>>   Get all meter list api call   <<<<<<<<<<<<<<<<<---
  getMeterList(request) {
    return methods.get('services', request)
  },

  // --->>>>>>>>>>>>>>>>   Get all lot list api call   <<<<<<<<<<<<<<<<<---
  getLotList(request) {
    return methods.get('coprop-lots?site_id=' + request.site_id + '&service_type_id=' + request.service_type_id)
  },

  // --->>>>>>>>>>>>>>>>   Get address book based on site and meter type ID list api call   <<<<<<<<<<<<<<<<<---
  getAddressBook(request) {
    return methods.get('lot-owners?page=' + request.page, request)
  },

  // --->>>>>>>>>>>>>>>>   update address book api call   <<<<<<<<<<<<<<<<<---
  updateAddressBook(request) {
    return methods.put('lot-owner', request)
  },

  // --->>>>>>>>>>>>>>>>   Get session reading api call   <<<<<<<<<<<<<<<<<---
  getSessionReading(request) {
    return methods.get('co-prop-lots?site_id=' + request.site_id + '&service_type_id=' + request.service_type_id)
  },


  //Sessions
  // --->>>>>>>>>>>>>>>>  Get open session list api call   <<<<<<<<<<<<<<<<<---
  getOpenSessionList() {
    return methods.get('co-prop-service')
  },

  // --->>>>>>>>>>>>>>>>  Get selected open session list api call   <<<<<<<<<<<<<<<<<---
  getSelectedSessionList(request) {
    return methods.get('co-prop-lots?site_id=' + request.site_id + '&service_type_id=' + request.service_type_id + '&page=' + request.page)
  },

  // --->>>>>>>>>>>>>>>>  Get getOutlierSessionList open session list api call   <<<<<<<<<<<<<<<<<---
  getOutlierSessionList(request) {
    return methods.get('co-prop-lots?site_id=' + request.site_id + '&service_type_id=' + request.service_type_id + '&page=' + request.page + '&outlier=' + request.outlier)
  },

  // --->>>>>>>>>>>>>>>>  Get Completed session list api call   <<<<<<<<<<<<<<<<<---
  getCompletedSessionList(request) {
    return methods.get('completed-session', request)
  },

  // --->>>>>>>>>>>>>>>>  Get completed session lots list api call   <<<<<<<<<<<<<<<<<---
  getCompletedSessionLots(request) {
    return methods.get('completed-session-lots', {
      site_id: request.site_id,
      service_type_id: request.service_type_id,
      created_at: request.created_at,
      uuid: request.uuid,
      page: request.page_no
    })
  },

  // --->>>>>>>>>>>>>>>>  Get common consumption history api call   <<<<<<<<<<<<<<<<<---
  getCommonConsumption(request) {
    return methods.get('common-consumption', request)
  },

  // --->>>>>>>>>>>>>>>>  Get Completed session list api call   <<<<<<<<<<<<<<<<<---
  getAdhocSessionList(request) {
    return methods.get('adhoc-list?site_id=' + request.site_id + '&service_type_id=' + request.service_type_id)
  },

  // --->>>>>>>>>>>>>>>>  Get Adhoc session lots list api call   <<<<<<<<<<<<<<<<<---
  getAdhocSessionLots(request) {
    return methods.get('adhoc-list?site_id=' + request.site_id + '&service_type_id=' + request.service_type_id + '&created_at=' + request.created_at)
  },

  // --->>>>>>>>>>>>>>>>  Get Adhoc session lots list api call   <<<<<<<<<<<<<<<<<---
  getBillValue(request) {
    return methods.post('genrate-bill', request)
  },

  // --->>>>>>>>>>>>>>>>  Get completed session lots list api call   <<<<<<<<<<<<<<<<<---
  uploadSessionData(request) {
    return methods.multipart('session', request)
  },

  // --->>>>>>>>>>>>>>>>  closed session lots list api call   <<<<<<<<<<<<<<<<<---
  closedSession(request) {
    return methods.get('completed', request)
  },

  // --->>>>>>>>>>>>>>>>  discard session lots list api call   <<<<<<<<<<<<<<<<<---
  discardSession(request) {
    return methods.get('discard?site_id=' + request.site_id + '&service_type_id=' + request.service_type_id)
  },

  // Rolls back (voids) a closed session by uuid, with an optional reason. 2026-10-19
  rollbackSession(request) {
    return methods.del('session/rollback', {
      uuid: request.uuid,
      reason: request.reason
    })
  },

  // Voids one closed-session row and re-bills it at the corrected closing reading; multipart when a photo is attached. 2026-10-19
  correctSessionRow(request) {
    const payload = {
      archived_session_id: request.archived_session_id,
      new_reading: request.new_reading
    }
    if (request.reason) payload.reason = request.reason
    if (!request.meter_image) {
      return methods.post('session/row/correct', payload)
    }
    const form = new FormData()
    Object.keys(payload).forEach(k => form.append(k, payload[k]))
    form.append('meter_image', request.meter_image)
    return methods.multipart('session/row/correct', form)
  },

  supportBowserAllocation(request) {
    return methods.get('support-bowser-allocation', {
      site_id: request.site_id
    })
  },





  //Mailing
  // --->>>>>>>>>>>>>>>>   Get Co Prop list api call   <<<<<<<<<<<<<<<<<---
  getMailScheduleList(request) {
    return methods.get('mail-scheduling', request)
  },

  // --->>>>>>>>>>>>>>>>   Get Co Prop list api call   <<<<<<<<<<<<<<<<<---
  changeMailStatus(request) {
    return methods.post('mail-status', request)
  },
  getMailReport(request) {
    return methods.get('mail-report', request)
  },
  checkFailedMailings(request) {
    return methods.get('check-previous-failed-mailings', request)
  },

  //MOBILE USERS
  // --->>>>>>>>>>>>>>>>   mobile user list api call   <<<<<<<<<<<<<<<<<---
  getSurvoyorList() {
    return methods.get('mobile-user')
  },

  // --->>>>>>>>>>>>>>>>   add mobile user api call   <<<<<<<<<<<<<<<<<---
  addSurvoyor(request) {
    return methods.post('mobile-user', request)
  },

  // --->>>>>>>>>>>>>>>>   add mobile user api call   <<<<<<<<<<<<<<<<<---
  updateSurvoyor(request) {
    return methods.put('edit/mobile-user', request)
  },




  //SUPER ADMIN
  dashboardStats() {
    return methods.get('dashboard-stats')
  },

  //Service Provider
  // --->>>>>>>>>>>>>>>>   Get Service Provider api call   <<<<<<<<<<<<<<<<<---
  getServiceProvider(pageNo) {
    return methods.get('service-providers?page=' + pageNo)
  },

  // --->>>>>>>>>>>>>>>>   Get Service Provider api call   <<<<<<<<<<<<<<<<<---
  serviceProviderStatusChange(request) {
    return methods.del('service-provider', request)
  },


  // --->>>>>>>>>>>>>>>>   Add Service Provider api call   <<<<<<<<<<<<<<<<<---
  addServiceProvider(request) {
    return methods.post('service-provider', request)
  },

  // --->>>>>>>>>>>>>>>>   Update Service Provider api call   <<<<<<<<<<<<<<<<<---
  updateServiceProvider(request) {
    return methods.put('service-provider', request)
  },

  //Site Management
  // --->>>>>>>>>>>>>>>>   Get Site Management api call   <<<<<<<<<<<<<<<<<---
  fetchServiceProvider() {
    return methods.get('fetch-service-providers')
  },

  // --->>>>>>>>>>>>>>>>   Get rate list api call   <<<<<<<<<<<<<<<<<---
  fetchRates() {
    return methods.get('fetch-rates')
  },

  // --->>>>>>>>>>>>>>>>   Get Site Management api call   <<<<<<<<<<<<<<<<<---
  getSiteList(pageNo) {
    return methods.get('sitelists?page=' + pageNo)
  },

  getSiteForEdit(params) {
    return methods.get('site-edit?site_id=' + params.site_id + '&service_provider_id=' + params.service_provider_id + '&service_type_id=' + params.service_type_id)
  },

  // --->>>>>>>>>>>>>>>>   Get Site Management api call   <<<<<<<<<<<<<<<<<---
  getSiteDetail(request) {
    return methods.get('lots-barcode-details?service_provider_id=' + request.service_provider_id + '&service_type_id=' + request.service_type_id + '&site_id=' + request.site_id + '&page=' + request.page)
  },


  // --->>>>>>>>>>>>>>>>   Add Site Management api call   <<<<<<<<<<<<<<<<<---
  addSite(request) {
    return methods.post('site', request)
  },

  // --->>>>>>>>>>>>>>>>   Update Site Management api call   <<<<<<<<<<<<<<<<<---
  updateSite(request) {
    return methods.put('site', request)
  },

  // --->>>>>>>>>>>>>>>>   Update Site Service (tax config) api call   <<<<<<<<<<<<<<<<<---
  updateSiteService(id, data) {
    return methods.put('site-service/' + id, data)
  },

  changeServiceProvider(request) {
    return methods.post('site/change-service-provider', request);
  },

  getSiteQuotePartTemplate(request) {
    return methods.get('site-quote-part-template', {
      site_id: request.site_id,
      service_type_id: request.service_type_id
    })
  },

  uploadSiteQuotePart(request) {
    return methods.multipart('site-quote-part', request)
  },

  //Rate Management
  // --->>>>>>>>>>>>>>>>   Get rate Management api call   <<<<<<<<<<<<<<<<<---
  getRateList(page) {
    return methods.get('rate-management?page=' + page)
  },

  // --->>>>>>>>>>>>>>>>   Add rate Management api call   <<<<<<<<<<<<<<<<<---
  addRate(request) {
    return methods.post('rate-management', request)
  },

  // --->>>>>>>>>>>>>>>>   Update rate Management api call   <<<<<<<<<<<<<<<<<---
  updateRate(request) {
    return methods.put('rate-management', request)
  },

  // --->>>>>>>>>>>>>>>>   rate status change api call   <<<<<<<<<<<<<<<<<---
  delRate(request) {
    return methods.del('rate-management', request)
  },

  // --->>>>>>>>>>>>>>>>   Get User Details api call   <<<<<<<<<<<<<<<<<---
  fileUpload(request) {
    return methods.multipart('lots-import-excel', request);
  },
  fileFormatDownload() {
    return methods.get('site-csv-dump');
  },
  completedSessionMail(request) {
    return methods.post('completed-session-mail?type=' + request.type, request)
  },
  completedSessionMailAnother(request) {
    return methods.post('completed-session-mail-another?type=' + request.type, request)
  },
  cronBillRate() {
    return methods.get('cron-trigger')
  },
  cronAnother() {
    return methods.get('cron-trigger-another')
  },
  adhocSessionMail(request) {
    return methods.post('mail', request)
  },
  previousUnitAdhocLot(request) {
    return methods.get('previous-unit', request)
  },
  changeAdminPassword(request) {
    return methods.put('change-password', request)
  },
  mailChecker(request) {
    return methods.post('mail_check', request)
  },
  getLogs(params) {
    let query = 'logs?page=' + (params.page || 1)
    if (params.date)  query += '&date='  + params.date
    if (params.level) query += '&level=' + params.level
    return methods.get(query)
  },
  landingPageCount() {
    return methods.get('landing-page-count')
  },
  completedSessionHome() {
    return methods.get('landing-page-completedSession')
  },
  forgotPassword(request) {
    return methods.post('forgot-password', request)
  },
  toggleUser(request) {
    return methods.put('mobile-user', request)
  },

  // Tenant Preferences — timezone, delivery hour
  getTimezones() {
    return methods.get('timezones')
  },
  getTenantPreferences() {
    return methods.get('preferences')
  },
  updateTenantPreferences(request) {
    return methods.patch('preferences', request)
  },

  // Site Preferences (Admin role)
  getAllSites() {
    return methods.get('all-sites')
  },
  getUserSitePreferences() {
    return methods.get('user/site-preferences')
  },
  updateUserSitePreferences(request) {
    return methods.put('user/site-preferences', request)
  },

  // Site Preferences (SuperAdmin support)
  getSuperAdminUserSitePreferences(userId) {
    return methods.get('user-site-preferences', { user_id: userId })
  },

  // Integration Tokens (SuperAdmin)
  getIntegrationTokens() {
    return methods.get('integration-tokens')
  },
  createIntegrationToken(request) {
    return methods.post('integration-tokens', request)
  },
  revokeIntegrationToken(id) {
    return methods.del(`integration-tokens/${id}`)
  },
  fetchSitesByProvider(serviceProviderId) {
    return methods.get('fetch-sites?service_provider_id=' + serviceProviderId)
  },
  uploadBatchUpdate(formData) {
    return methods.multipart('lots-batch-update', formData)
  },
  getLastSessionBySite() {
    return methods.get('last-session-by-site')
  },

  // Vilogi Configuration (SuperAdmin)
  getVilogiConfig(serviceProviderId) {
    return methods.get(`vilogi-config/${serviceProviderId}`)
  },
  saveVilogiConfig(request) {
    return methods.post('vilogi-config', request)
  },
  deleteVilogiConfig(serviceProviderId) {
    return methods.del(`vilogi-config/${serviceProviderId}`)
  },
  toggleVilogiWebhook(serviceProviderId) {
    return methods.post(`service-provider/${serviceProviderId}/vilogi-toggle`)
  },

  // Vilogi Adherent (idAdh) Sync — full site backfill (SuperAdmin)
  syncVilogiAdherents(siteId) {
    return methods.post(`sites/${siteId}/vilogi-adherents/sync`)
  },

  // Accounting Contrepartie Management (SuperAdmin)
  getContreparties(siteId) {
    return methods.get(`sites/${siteId}/contreparties`)
  },
  saveContrepartie(siteId, request) {
    return methods.post(`sites/${siteId}/contreparties`, request)
  },
  deleteContrepartie(siteId, chargeType) {
    return methods.del(`sites/${siteId}/contreparties/${chargeType}`)
  },

  // Vilogi Email Mismatch Review (Admin)
  getVilogiEmailMismatches(params) {
    return methods.get('vilogi-email-mismatches', params)
  },
  updateVilogiEmailMismatch(id, request) {
    return methods.put(`vilogi-email-mismatches/${id}`, request)
  },

  // Vilogi Journal Entry Batch Trigger / Cancel (Admin)
  triggerVilogiBatch(request) {
    return methods.post('completed-session-vilogi-trigger', request)
  },
  cancelVilogiBatch(request) {
    return methods.post('completed-session-vilogi-cancel', request)
  },
  // Reverses every synced Vilogi posting of a session and cancels pending ones; bills and session state are untouched. 2026-10-20
  reverseVilogiBatch(request) {
    return methods.post('completed-session-vilogi-reverse', request)
  },

  // Vilogi Journal Entry — single-entry retry/reverse (Admin)
  retryVilogiEntry(entryId) {
    return methods.post(`vilogi-journal-entries/${entryId}/retry`)
  },
  reverseVilogiEntry(entryId) {
    return methods.post(`vilogi-journal-entries/${entryId}/reverse`)
  },

  // Single lot's Vilogi/mail detail — cheaper than reloading a whole page of lots (Admin)
  getArchivedSessionDetails(id) {
    return methods.get('completed-session-details', { id })
  }
}



// WEBPACK FOOTER //
// ./src/services/api.js